<template>
  <div class="relative">
    <div class="export-button flex items-center rounded-md overflow-hidden">
      <button class="flex items-center gap-1.5 pl-2 pr-2.5 py-1.5 border-r border-border-normal transition-colors duration-100 hover:bg-neutral-25"
      @click="exportFormat('csv', 'all')">
        <ExportCSVIcon class="text-icon-normal" />
        <BaseText type="label" size="sm" class="text-text-muted">
          Export CSV
        </BaseText>
      </button>
      <button class="w-8 h-8 flex items-center justify-center transition-colors duration-100"
      :class="isOpen ? 'bg-neutral-25' : 'hover:bg-neutral-25'"
      @click="isOpen = !isOpen">
        <ChevronIcon class="text-icon-normal transition-transform duration-100"
        :style="{ transform: isOpen ? 'scaleY(-1)' : 'scaleY(1)' }" />
      </button>
    </div>
    <transition>
      <div v-if="isOpen" class="dropdown-container flex flex-col gap-0.5 p-1" v-on-clickaway="() => isOpen = false">
        <button v-for="(option, index) in exportOptions" :key="`export-option-${index}`"
        class="group w-full flex items-center gap-2 px-2 py-1.5 rounded-md transition-colors duration-100 hover:bg-neutral-25"
        @click="option.action()">
          <BaseText type="body" size="sm"  class="text-text-muted">
            {{ option.label }}
          </BaseText>
          <!-- Pinned Indicator -->
          <div v-if="option.exportPinned" class="w-max flex items-center p-0.5 rounded-md bg-neutral-25 transition-colors duration-100 group-hover:bg-neutral-50">
            <PinIcon :width="16" :height="16" class="text-icon-normal" />
            <BaseText type="label" size="xs" class="text-icon-normal px-1">
              Pinned
            </BaseText>
          </div>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway2'

import ChevronIcon from '../../globals/Icons/ChevronIcon.vue'
import ExportCSVIcon from '../../globals/Icons/ExportCSVIcon.vue'
import PinIcon from '../../globals/Icons/SpyderV2Icons/PinOutlineIcon.vue'

export default {
  name: 'HooksExportMenu',
  mixins: [clickaway],
  components: {
    ChevronIcon,
    ExportCSVIcon,
    PinIcon
  },
  data () {
    return {
      isOpen: false,
      exportOptions: [
        {
          label: 'Export CSV',
          exportPinned: false,
          action: () => this.exportFormat('csv', 'all')
        },
        {
          label: 'Export CSV',
          exportPinned: true,
          action: () => this.exportFormat('csv', 'pinned')
        },
        {
          label: 'Copy Hooks as Text',
          exportPinned: false,
          action: () => this.exportFormat('text', 'all')
        },
        {
          label: 'Copy Hooks as Text',
          exportPinned: true,
          action: () => this.exportFormat('text', 'pinned')
        }
      ]
    }
  },
  methods: {
    exportFormat (format, scope) {
      this.$emit('export', { format, scope })
      this.isOpen = false
    },
  }
}
</script>

<style scoped>
.export-button {
  box-shadow: 0 2px 4px -1.5px rgba(24, 35, 68, 0.04), 0 1px 2px -0.75px rgba(24, 35, 68, 0.04), 0 0 0 1px rgba(0, 40, 136, 0.08);
}
.dropdown-container {
  position: absolute;
  right: 0px;
  top: calc(100% + 6px);
  width: 262px;
  border-radius: 10px;
  box-shadow: 0 1px 2px 0 rgba(4, 26, 75, 0.13), 0 0 0 1px rgba(0, 56, 108, 0.08);
  background-color: white;
  z-index: 1000;
}

.v-enter-active, .v-leave-active {
  transition: opacity 75ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
</style>
